/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { TocComponentDisplay } from "cms/components/components/toc/display";
import { TocComponentEditor } from "cms/components/components/toc/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function TocComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <TocComponentDisplay />,
        editComponent: <TocComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

TocComponent.displayName = "TocComponent";
export { TocComponent };
